import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17.727 6.457l-8.566 8.517-2.852-2.878a1.203 1.203 0 00-1.643-.056l-.028.023a1.198 1.198 0 00-.11 1.69c.019.019.035.038.054.056l3.727 3.731a1.193 1.193 0 001.69.002l9.42-9.384a1.196 1.196 0 00.005-1.692l-.019-.019a1.192 1.192 0 00-1.676.009z"
}), 'AgreeHeavy');